import { HttpParams } from "@angular/common/http";

export class NoUIBlockHttpParams extends HttpParams {
    constructor(public noUIBlock: boolean) {
     super();
    }
  }